import React from 'react';

interface SpinnerProps {
    height?: string;
    width?: string;
}

const Spinner = ({ height = '300px', width = '300px' }: SpinnerProps) => {
    return (
        <div className={`w-full h-[${height}] flex items-center justify-center`}>
            <div
                className="flex justify-center items-center loader w-6 h-6 border-4 border-gray-200 border-t-4 border-t-success110 dark:border-t-success090 rounded-full animate-spin"
            ></div>
        </div>
    );
};

export default Spinner;
